import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {ref} from '../../config/firebase';

export default class DetailPortfolio extends Component {
    //this.props.match.params.key
    constructor(props) {
        super(props);
        this.state = {
            items: []
        };

        this.dbItems = ref.child('portfolio');
    }

    componentDidMount() {
        this.dbItems.child(this.props.match.params.key).on("value", snapshot => {
            var items = [];

            items = snapshot.val();

            this.setState({items});

        });

    }

    mapsType(aType) {
        return (aType === 'mobile')? 'Mobile Application' : ((aType === 'desktop')? 'Desktop Application' : 'Web Application');
    }
    render() {

        return (

            <div className="bg_color">
                <div className="btn-back">
                    <Link className="btn btn-warning" to="/"><i className="fa fa-angle-double-left"></i> Back</Link>
                </div>
                <h1 className="text-center mt0 uppercase">{this.state.items.name}</h1>

                <div className="row">
                    <div className="col-md-6">
                        <img src={this.state.items.img1} className="portfolio-img" alt=""/>
                    </div>
                    <div className="col-md-6">
                        <img src={this.state.items.img2} className="portfolio-img" alt=""/>
                    </div>
                </div>

                <h2 className="text-center">{this.mapsType(this.state.items.type)}</h2>

                <div className="row">
                    <p className="text-justify col-md-6 col-md-offset-3">
                        {this.state.items.description}
                    </p>

                </div>
                <div className="row">
                    <p className="text-center">
                        <a href={this.state.items.link} className="btn btn-info">{this.state.items.usage}</a>
                    </p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/guest/components/DetailPortfolio.js